@for (option of options; track option) { @if (!option.icon) {
<img class="svg-image" [src]="option.path" (click)="select(option)" />
} @if (option.icon) {
<div class="svg-button" (click)="select(option)">
    <i [class]="option.icon"></i>
</div>
} } @if (parent) {
<div class="svg-button" [class]="removeSvgClassname">
    <i class="fas fa-trash"></i>
</div>
}
